import type { ThemeConfig } from 'antd';
import tokens from './tokens';

const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: tokens.brand[800],
    colorLink: tokens.accent[500],
    colorSuccess: tokens.semantic.success,
    colorWarning: tokens.semantic.warning,
    colorError: tokens.semantic.danger,
    colorTextBase: tokens.brand[900],
    colorBgContainer: '#FFFFFF',
    colorBgLayout: tokens.brand[50],
    colorBorder: tokens.brand[300],
    borderRadius: 10,
    fontFamily: tokens.fontFamily.sans,
    fontSize: 16,
  },
  components: {
    Button: {
      controlHeightLG: 48,
      primaryShadow: 'none',
      defaultShadow: 'none',
    },
    Input: {
      controlHeightLG: 48,
      activeBorderColor: tokens.accent[500],
      hoverBorderColor: tokens.brand[300],
    },
    Table: {
      headerBg: tokens.brand[100],
      headerColor: tokens.brand[900],
      borderColor: tokens.brand[300],
    },
  },
};

export default antdTheme;
